import { render, staticRenderFns } from "./BasicInfoPlate.vue?vue&type=template&id=d63d3f54&"
import script from "./BasicInfoPlate.vue?vue&type=script&lang=js&"
export * from "./BasicInfoPlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports